import React from 'react';
import {BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {getSummary} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {BuilderAnnuitySourceForm} from './BuilderAnnuitySourceForm';
import {getCurrencyFloat} from '../../../utils/currencyFormatter';

interface AnnuitySourceSubplanProps {
  subPlan: BuilderPot_dentistChildren;
  isSelected: boolean;
  handleChange: () => void;
}

export const AnnuitySourceSubplan: React.FC<AnnuitySourceSubplanProps> = ({
  subPlan,
  isSelected,
  handleChange,
}) => {
  return (
    <PlanRow
      id={subPlan.id}
      reccId={subPlan.originalOvrId ?? null}
      isSelected={isSelected}
      isSubplan
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent={false}
        flat
        compact
        validationLevel="nothing"
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={subPlan.id}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            {getSummary(subPlan)}
          </>
        }
        summaryTrailing={
          isSelected ? <PlanValidationIcon formikKeyPrefix="annuity" /> : undefined
        }
      >
        <BuilderAnnuitySourceForm
          pot={subPlan}
          maxAmount={getCurrencyFloat(subPlan.totalValue)}
        />
      </PlanAccordionShell>
    </PlanRow>
  );
};
